/* eslint-disable react-hooks/exhaustive-deps */
// ProtectedRoute.js
import { Outlet, useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks/hooks";
import React, { useEffect } from "react";

const ProtectedRoute = (): JSX.Element => {
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const navigate = useNavigate();
  console.log("protected ", userInfo);
  useEffect(() => {
    if (userInfo?.id == null) {
      navigate("/login");
    }
  }, [userInfo]);

  // show unauthorized screen if no user is found in redux store

  // returns child route elements
  return <Outlet />;
};
export default ProtectedRoute;
